import { Button, Col, Row, Space, Typography } from 'antd';
import { AddDeliveryAddressModal } from 'components/createDeliveryAddress/AddDeliveryAddressModal';
import { DeploymentRequestLabels } from 'models/DeploymentRequest';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { useState } from 'react';
import { useGetSparingRequestConfigurationQuery } from 'redux/services/calvin/sparingRequestConfig';
import { colors, toRgba } from 'styles/colors';
import { LocationsFilters } from '../common';
const { Title } = Typography;

const styles: InlineStylesModel = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: toRgba(colors.royalBlueLight, 0.4),
    justifyContent: 'space-between',
    width: '100%',
    padding: 24,
    borderBottom: '2px solid rgba(0,0,0,.1)',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10
  },
  title: {
    margin: 0,
    fontWeight: 'normal'
  },
  nextButton: {
    margin: 'auto',
    borderRadius: '5px'
  }
};

export const HeaderControls = (): JSX.Element => {
  const [showAddAddressModal, _setShowAddAddressModal] = useState(false);

  const { data: configData, isLoading: isConfigLoading } = useGetSparingRequestConfigurationQuery();

  const isManualAddressEntryAllowed = !isConfigLoading && configData?.addressDetails.isManualAddressEntryAllowed;

  return (
    <Row align="middle" style={styles.container}>
      <Col xs={24} lg={6}>
        <Space style={{ flex: 1, justifyContent: 'center' }} size={0} direction="vertical">
          <Title level={4} style={styles.title}>
            {'Search For '} {DeploymentRequestLabels.installAddress}
          </Title>
        </Space>
      </Col>
      <Col xs={24} lg={18} style={{ textAlign: 'right' }}>
        <Space className="narrow-wrap">
          <LocationsFilters />
          {isManualAddressEntryAllowed && (
            <Button disabled={!isManualAddressEntryAllowed} type="primary" style={styles.addAddressButton} onClick={(): void => _setShowAddAddressModal(true)}>
              Add Manual Address
            </Button>
          )}

          <AddDeliveryAddressModal
            addressTypes={['Install']}
            show={showAddAddressModal}
            key={1}
            onClose={(): void => {
              _setShowAddAddressModal(false);
            }}
          />
        </Space>
      </Col>
    </Row>
  );
};
